'use client';

import { flag } from '@/components/flags/client';
import type { FlagEntities } from '@/components/flags/types';
import { envVarsProvider } from '@/utils/envVars/envVars';


export const showAuditLogs = flag<boolean, FlagEntities>( {
  key: 'show-audit-logs',
  description: 'Show access to the audit logs page',
  defaultValue: false,
  decide( { entities } ) {
    return entities?.authContext?.canAccess( 'can_view_audit_logs' ) ?? false;
  }
} );

export const showDeleteUser = flag<boolean, FlagEntities>( {
  key: 'show-delete-user',
  description: 'Show the delete user option',
  defaultValue: false,
  decide( { entities } ) {
    return entities?.authContext?.canAccess( 'can_manage_users' ) ?? false;
  }
} );

export const showSidebarAuditLogs = flag<boolean, FlagEntities>( {
  key: 'show-sidebar-audit-logs',
  description: 'Show audit logs link in sidebar',
  defaultValue: false,
  decide( { entities } ) {
    return entities?.authContext?.canAccess( 'can_view_audit_logs' ) ?? false;
  }
} );

export const showSidebarUsers = flag<boolean, FlagEntities>( {
  key: 'show-sidebar-users',
  description: 'Show users link in sidebar',
  defaultValue: false,
  decide( { entities } ) {
    return entities?.authContext?.canAccess( 'can_manage_users' ) ?? false;
  }
} );

export const showSourceComparison = flag<boolean, FlagEntities>( {
  key: 'show-source-comparison',
  description: 'Enable source comparison feature in evaluations',
  defaultValue: false,
  decide() {
    return false;
  }
} );

export const showApiKeyScoping = flag<boolean, FlagEntities>( {
  key: 'show-api-key-scoping',
  description: 'Enable scoped API key creation)',
  defaultValue: false,
  decide() {
    return false;
  }
} );

export const showMemberRole = flag<boolean, FlagEntities>( {
  key: 'show-member-role',
  description: 'Show the member role in the role dropdown. Set per-deployment via the SHOW_MEMBER_ROLE env var; flip in lockstep with the backend MEMBER_ROLE_ENABLED env var.',
  defaultValue: false,
  decide() {
    return envVarsProvider.get( 'SHOW_MEMBER_ROLE' );
  }
} );

export const allFlags = [
  showAuditLogs,
  showDeleteUser,
  showSidebarAuditLogs,
  showSidebarUsers,
  showSourceComparison,
  showApiKeyScoping,
  showMemberRole
];